export const mockMissions = [
  {
    id: 2,
    step: "STEP 1",
    title: "ชวนเพื่อนตั้งทีม",
    subtitle: "ชวนเพื่อนมาร่วมสะสมคะแนน ยิ่งเล่นยิ่งสนุก",
    iconType: "users",
    bgColor: "#FFF3DC",
    iconBg: "#FF8A00",
  },
  {
    id: 1,
    step: "STEP 2",
    title: "สแกนบิลสะสมคะแนน",
    subtitle: "สแกนใบเสร็จเพื่อรับคะแนนสะสม",
    iconType: "camera",
    bgColor: "#DCFCE7",
    iconBg: "#10C851",
  },
  {
    id: 3,
    step: "STEP 3",
    title: "ดูอันดับคะแนน",
    subtitle: "ติดตามอันดับของคุณและลุ้นรางวัล",
    iconType: "trophy",
    bgColor: "#FFFADC",
    iconBg: "#F7C500",
  },
];

// เงื่อนไขหน้าภารกิจ
export const missionTerms = [
  "ขั้นตอนที่ 1 : ผู้เข้าร่วมกิจกรรม เข้าร่วมตั้งทีม (สถานะเป็นหัวหน้าทีม หรือ ผู้ร่วมทีม)",
  "ขั้นตอนที่ 2 : สแกนบิลสะสมคะแนน จาก QR Code ท้ายใบเสร็จที่มีหมายเลขสมาชิกบิ๊กพอยต์ ตรงกับที่ร่วมกิจกรรม ตั้งทีมไว้",
  "ขั้นตอนที่ 3 : ทีมที่สะสมคะแนนได้สูงสุด ลำดับที่ 1 - 5 เท่านั้น (กรณี มีทีมที่คะแนนเท่ากัน ทางบริษัทฯ ขอตัดสินจากเวลาที่ทำภารกิจสำเร็จเร็วที่สุด) และ ทีมที่ชนะจะต้องตั้งทีมให้สมบูรณ์ (มีสมาชิกครบ 4 ท่าน)",
  "ขอสงวนสิทธิ์พนักงาน BJC – Big C ไม่สามารถร่วมกิจกรรมนี้ได้",
];

// เงื่อนไขหน้าทีม
export const teamTerms = [
  "ชื่อทีม ต้องมีคำว่า “บิ๊กซี”,“Big C” หรือ “BigC” เป็นส่วนหนึ่งของชื่อทีม",
  "ผู้สร้างทีมจะเป็น “หัวหน้าทีม” ทันที และ สามารถเชิญชวนเพื่อนใน line มาเป็น “ผู้ร่วมทีม” ได้",
  "1 ทีมประกอบไปด้วยสมาชิกทั้งหมด 4 ท่าน โดยเป็นหัวหน้าทีม 1 ท่าน และ สมาชิกในทีม สูงสุด 3 ท่าน",
  "หัวหน้าทีม และสมาชิกในทีม จะต้องเป็นสมาชิกบิ๊กพอยต์และลงทะเบียนบนไลน์บิ๊กซี แล้วเท่านั้น ",
  "สิทธิ์สมาชิกใหม่ นับจากการสมัครสมาชิกบิ๊กพอยต์ ระหว่างวันที่ 27 เม.ย. – 27 พ.ค. 69 เท่านั้น",
  "จำกัด 1 สมาชิกบิ๊กพอยต์ เข้าร่วมทีมได้สูงสุด 1 ทีม โดยไม่สามารถยกเลิก หรือ ปรับเปลี่ยนสถานะ ได้",
];

// เงื่อนไขหน้าประวัติบิล
export const historyTerms = [
  "หมายเลขสมาชิกบิ๊กพอยต์ที่ระบุในใบเสร็จ ต้องตรงกับ ที่ลงทะเบียนร่วมกิจกรรม จึงจะสะสมคะแนนได้",
  "สมาชิกบิ๊กพอยต์ ที่ซื้อสินค้าที่ร่วมรายการ จะได้รับ QR Code แสดงที่ท้ายใบเสร็จ โดย",
  "- ระบบคำนวณ ยอดซื้อสินค้าร่วมรายการ 1 บาท = 1 คะแนน ",
  "- สำหรับสมาชิกใหม่ ตามเงื่อนไข รับ 1 บาท = 2 คะแนน ทุกใบเสร็จ (สมาชิกที่สมัคร ระหว่าง 27 เม.ย. – 27 พ.ค. 69 )",
  "- ยอดซื้อที่นำมาคำนวณคะแนน ยกเว้นการซื้อสินค้าในพื้นที่ขายของ Big pack สินค้าร้านยาเพรียวประเภท ยา เวชภัณฑ์ เวชสำอาง บุหรี่ สุรา เครื่องดื่มที่มีแอลกอฮอล์ เครื่องดื่มชูกำลังแบบแพ็ค กาแฟกระป๋องแบบแพ็ค เฮลซ์บลูบอยน้ำหวานเข้มข้น น้ำมันปาล์ม น้ำมันมะพร้าว น้ำมันถั่วเหลือง น้ำมันรำข้าว น้ำมันทานตะวันบางรายการ อายิโนะโมะโต๊ะ 80 กรัมแพ็ค 20 อายิโนะโมะโต๊ะ 1 กก.แพ็ค 20 นมผงดัดแปลงสำหรับทารก และนมผงดัดแปลงสูตรต่อเนื่องสำหรับทารกและเด็กเล็ก สินค้าแฮปปี้ ไพรซ์ สินค้าแฮปปี้ ไพรซ์ โปร สินค้าใช้คะแนนแลกฟรี กระเช้าของขวัญ บัตรกำนัล การเติมเงินมือถือทั้งแบบสลิปและออนไลน์ การเติมเงินเข้ากระเป๋าอิเล็กทรอนิกส์ (E wallet) บิลเพย์เม้นท์ และสินค้ายกเว้นอื่น ๆ ตามที่บริษัทกำหนด และยกเว้นการซื้อสินค้าในร้านแว่นตา ร้านค้าในพลาซ่า ศูนย์อาหาร การซื้อเงินผ่อน และการซื้อเหมา",
  "กรณีลูกค้าขอคืนสินค้าที่ร่วมรายการ ภายใต้ใบเสร็จที่มีการได้รับคะแนนพิเศษจากโปรโมชั่นนี้ ระบบจะมีการเรียกคะแนนสะสมคืน",
  "บริษัทฯ จะไม่ทำการปรับคะแนนให้กรณีที่ลูกค้าไม่ได้แจ้งหมายเลขสมาชิกบิ๊กพอยต์   หรือ แจ้งข้อมูลผิด และหากพบว่ามีการกระทำใดๆ ที่เข้าข่ายฉ้อฉล หลอกลวง ปลอมแปลง หรือทุจริต เพื่อให้ได้มาซึ่งคะแนนสะสม ไม่ว่าจะเป็นบางส่วนหรือทั้งหมด บริษัทฯ จะยกเลิกคะแนนสะสม และดำเนินการทางกฏหมายต่อผู้กระทำ กรณีมีข้อพิพาท หรือข้อโต้แย้งใดๆ คำตัดสินของบริษัทฯ ถือเป็นที่สิ้นสุด",
  "ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข / ยกเลิกสิทธิพิเศษนี้ โดยไม่ต้องแจ้งให้ลูกค้าทราบล่วงหน้า",
];

// เงื่อนไขหน้าอันดับ
export const rankingTerms = [
  "ทีมที่สะสมคะแนนได้สูงสุด ลำดับที่ 1-5 ได้รับรางวัลกินไก่ฟรีตลอดปี (กรณี มีทีมที่คะแนนเท่ากัน ทางบริษัทฯ ขอตัดสินจากเวลาที่ทำภารกิจสำเร็จเร็วที่สุด)",
  "ทีมที่มีสิทธิได้รับรางวัลต้อง มีสมาชิกครบ 4 ท่าน เท่านั้น",
  "ของรางวัล กินไก่ฟรี ทั้งปี (ยกทีม)",
  "- จำกัด 1 สมาชิก / 1 ตัว / สัปดาห์ (ตลอด 1 ปี = 52 สัปดาห์)",
  "ระยะเวลาการรับของรางวัล ตั้งแต่ 1 พฤษภาคม 2569 - 30 เมษายน 2570",
  "การรับของรางวัล แสดงคูปองที่จุดบริการลูกค้า ที่ บิ๊กซี บิ๊กซีมาร์เก็ต บิ๊กซีฟู้ดส์เพลส ทุกสาขา",
  "ได้รับคูปองในเมนูคูปองของฉัน ผ่านช่องทาง Line Big C TH ทุกวันจันทร์",
  "คูปองมีระยะเวลาการใช้ นับตั้งแต่ วันจันทร์ - วันอาทิตย์ ของแต่ละสัปดาห์",
  "กรณี ไม่มารับสิทธิ ตามระยะที่กำหนด ถือว่าลูกค้าสละสิทธิ ของสัปดาห์นั้นๆ (ขอสงวนสิทธิ ไม่คืนคูปอง และ แลกเปลี่ยนเป็นเงินสด)",
  "กรณี รับแทน ต้องถ่ายบัตรประชาชน และ เอกสารมอบอำนาจมาแสดงต่อพนักงาน",
  "ขอสงวนสิทธิ์พนักงาน BJC - Big C ไม่สามารถร่วมกิจกรรมนี้ได้",
];
